import React from 'react';
import './link.scss';

const Link = (props) => {
    if (props.modal) {
        return (
            <a
                className="link"
                onClick={props.modal}
                {...props}
            >
                {props.name}
            </a>
        );
    }

    if (props.isButton) {
        return (
            <button
                className="link footer-button"
                onClick={props.onClick}
                style={{
                    border: 'none',
                    textAlign: 'start',
                    padding: 0,
                }}
                {...props}
            >
                {props.name}
            </button>
        );
    }

    return (
        <a
            className="link"
            href={decodeURIComponent(props.url)}
            {...props}
        >
            {props.name}
        </a>
    );
};

export default Link;
